// @ts-nocheck
/* eslint-disable */
export const appNavArrowRightIcon = {
    data: `<svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'nav-arrow-right' as const
};